// AUTOGENERATED, DO NOT EDIT DIRECTLY. RUN generate_court_data.pl to update
export default [
   {
      "circuit" : "01",
      "citation" : "1thBapCir.",
      "code" : "01bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - First Circuit",
      "subdomain" : "ecf.ca1.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1thBapCir.TEST.",
      "code" : "01baptest",
      "is_test" : true,
      "name" : "U.S. Test Bankruptcy Appellate Panel - First Circuit",
      "subdomain" : "ecf-test.ca1.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1stCir.",
      "code" : "01cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - First Circuit",
      "subdomain" : "ecf.ca1.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "01",
      "citation" : "1thCir.TEST.",
      "code" : "01caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - First Circuit (test)",
      "subdomain" : "ecf-test.ca1.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "02",
      "citation" : "2ndCir.",
      "code" : "02cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Second Circuit",
      "subdomain" : "ecf.ca2.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "02",
      "citation" : "2thCir.TEST.",
      "code" : "02caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Second Circuit (test)",
      "subdomain" : "ecf-test.ca2.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3rdCir.",
      "code" : "03cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Third Circuit",
      "subdomain" : "ecf.ca3.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3thCir.TEST.",
      "code" : "03caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Third Circuit (test)",
      "subdomain" : "ecf-test.ca3.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "03",
      "citation" : "3thCir.TRAIN.",
      "code" : "03caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Third Circuit (train)",
      "subdomain" : "ecf-train.ca3.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "04",
      "citation" : "4thCir.",
      "code" : "04cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Fourth Circuit",
      "subdomain" : "ecf.ca4.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "04",
      "citation" : "4thCir.TEST.",
      "code" : "04caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Fourth Circuit (test)",
      "subdomain" : "ecf-test.ca4.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "05",
      "citation" : "5thCir.",
      "code" : "05cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Fifth Circuit",
      "subdomain" : "ecf.ca5.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "05",
      "citation" : "5thCir.TEST.",
      "code" : "05caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Fifth Circuit (test)",
      "subdomain" : "ecf-test.ca5.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.",
      "code" : "06cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Sixth Circuit",
      "subdomain" : "ecf.ca6.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.TEST.",
      "code" : "06caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Sixth Circuit (test)",
      "subdomain" : "ecf-test.ca6.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "06",
      "citation" : "6thCir.TRAIN.",
      "code" : "06caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Sixth Circuit (train)",
      "subdomain" : "ecf-train.ca6.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "07",
      "citation" : "7thCir.",
      "code" : "07cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Seventh Circuit",
      "subdomain" : "ecf.ca7.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "08",
      "citation" : "8thCir.",
      "code" : "08cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Eighth Circuit",
      "subdomain" : "ecf.ca8.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "appellate"
   },
   {
      "circuit" : "08",
      "citation" : "8thCir.TRAIN.",
      "code" : "08caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Eighth Circuit (train)",
      "subdomain" : "ecf-train.ca8.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.",
      "code" : "09bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - Ninth Circuit",
      "subdomain" : "ecf.ca9.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.TEST.",
      "code" : "09baptest",
      "is_test" : true,
      "name" : "U.S. Test Bankruptcy Appellate Panel - Ninth Circuit",
      "subdomain" : "ecf-test.ca9.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thBapCir.TRAIN.",
      "code" : "09baptrain",
      "is_test" : true,
      "name" : "U.S. Train Bankruptcy Appellate Panel - Ninth Circuit",
      "subdomain" : "ecf-train.ca9.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.",
      "code" : "09cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Ninth Circuit",
      "subdomain" : "ecf.ca9.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.TEST.",
      "code" : "09caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Ninth Circuit (test)",
      "subdomain" : "ecf-test.ca9.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "9thCir.TRAIN.",
      "code" : "09caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Ninth Circuit (train)",
      "subdomain" : "ecf-train.ca9.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.",
      "code" : "10bap",
      "is_test" : false,
      "name" : "U.S. Bankruptcy Appellate Panel - Tenth Circuit",
      "subdomain" : "ecf.ca10.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.TEST.",
      "code" : "10baptest",
      "is_test" : true,
      "name" : "U.S. TEST Bankruptcy Appellate Panel - Tenth Circuit",
      "subdomain" : "ecf-test.ca10.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thBapCir.TRAIN.",
      "code" : "10baptrain",
      "is_test" : true,
      "name" : "U.S. Train Bankruptcy Appellate Panel - Tenth Circuit",
      "subdomain" : "ecf-train.ca10.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.",
      "code" : "10cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Tenth Circuit",
      "subdomain" : "ecf.ca10.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.TEST.",
      "code" : "10caetest",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Tenth Circuit (test)",
      "subdomain" : "ecf-test.ca10.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "10",
      "citation" : "10thCir.TRAIN.",
      "code" : "10caetrain",
      "is_test" : true,
      "name" : "U.S. Court of Appeals - Tenth Circuit (train)",
      "subdomain" : "ecf-train.ca10.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "11",
      "citation" : "11thCir.",
      "code" : "11cae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Eleventh Circuit",
      "subdomain" : "ecf.ca11.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "fc",
      "citation" : "FCir.",
      "code" : "cafc",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - Federal Circuit",
      "subdomain" : "ecf.cafc.uscourts.gov",
      "timezone" : null,
      "type" : "appellate"
   },
   {
      "circuit" : "dc",
      "citation" : "D.C.Cir.",
      "code" : "dccae",
      "is_test" : false,
      "name" : "U.S. Court of Appeals - D.C. Circuit",
      "subdomain" : "ecf.cadc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "appellate"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska",
      "code" : "akbke",
      "is_test" : false,
      "name" : "Alaska Bankruptcy Court",
      "subdomain" : "ecf.akb.uscourts.gov",
      "timezone" : "US/Alaska",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska.TEST.",
      "code" : "akbtest",
      "is_test" : true,
      "name" : "Alaska TEST Bankruptcy Court",
      "subdomain" : "ecf-test.akb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Alaska.TRAIN.",
      "code" : "akbtrain",
      "is_test" : true,
      "name" : "Alaska TRAIN Bankruptcy Court",
      "subdomain" : "ecf-train.akb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Ala.",
      "code" : "almbke",
      "is_test" : false,
      "name" : "Alabama Middle Bankruptcy Court",
      "subdomain" : "ecf.almb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ala.",
      "code" : "alnbke",
      "is_test" : false,
      "name" : "Alabama Northern Bankruptcy Court",
      "subdomain" : "ecf.alnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Ala.",
      "code" : "alsbke",
      "is_test" : false,
      "name" : "Alabama Southern Bankruptcy Court",
      "subdomain" : "ecf.alsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.E.D.Ark.",
      "code" : "arebke",
      "is_test" : false,
      "name" : "Arkansas Eastern Bankruptcy Court",
      "subdomain" : "ecf.areb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.W.D.Ark.",
      "code" : "arwbke",
      "is_test" : false,
      "name" : "Arkansas Western Bankruptcy Court",
      "subdomain" : "ecf.arwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Ariz.",
      "code" : "azbke",
      "is_test" : false,
      "name" : "Arizona Bankruptcy Court",
      "subdomain" : "ecf.azb.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Ariz.TEST",
      "code" : "azbtest",
      "is_test" : true,
      "name" : "Arizona TEST Bankruptcy Court",
      "subdomain" : "ecf-test.azb.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.C.D.Cal.",
      "code" : "cacbke",
      "is_test" : false,
      "name" : "California Central Bankruptcy Court",
      "subdomain" : "ecf.cacb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.E.D.Cal.",
      "code" : "caebke",
      "is_test" : false,
      "name" : "California Eastern Bankruptcy Court",
      "subdomain" : "ecf.caeb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.N.D.Cal.",
      "code" : "canbke",
      "is_test" : false,
      "name" : "California Northern Bankruptcy Court",
      "subdomain" : "ecf.canb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.",
      "code" : "casbke",
      "is_test" : false,
      "name" : "California Southern Bankruptcy Court",
      "subdomain" : "ecf.casb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.TEST.",
      "code" : "casbtest",
      "is_test" : true,
      "name" : "California Southern TEST Bankruptcy Court",
      "subdomain" : "ecf-test.casb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.S.D.Cal.TRAIN.",
      "code" : "casbtrain",
      "is_test" : true,
      "name" : "California Southern TRAIN Bankruptcy Court",
      "subdomain" : "ecf-train.casb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Colo.",
      "code" : "cobke",
      "is_test" : false,
      "name" : "Colorado Bankruptcy Court",
      "subdomain" : "ecf.cob.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.D.Conn.",
      "code" : "ctbke",
      "is_test" : false,
      "name" : "Connecticut Bankruptcy Court",
      "subdomain" : "ecf.ctb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "dc",
      "citation" : "Bankr.D.D.C.",
      "code" : "dcbke",
      "is_test" : false,
      "name" : "District Of Columbia Bankruptcy Court",
      "subdomain" : "ecf.dcb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.Del.",
      "code" : "debke",
      "is_test" : false,
      "name" : "Delaware Bankruptcy Court",
      "subdomain" : "ecf.deb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Fla.",
      "code" : "flmbke",
      "is_test" : false,
      "name" : "Florida Middle Bankruptcy Court",
      "subdomain" : "ecf.flmb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Fla.",
      "code" : "flnbke",
      "is_test" : false,
      "name" : "Florida Northern Bankruptcy Court",
      "subdomain" : "ecf.flnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Fla.",
      "code" : "flsbke",
      "is_test" : false,
      "name" : "Florida Southern Bankruptcy Court",
      "subdomain" : "ecf.flsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.M.D.Ga.",
      "code" : "gambke",
      "is_test" : false,
      "name" : "Georgia Middle Bankruptcy Court",
      "subdomain" : "ecf.gamb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ga.",
      "code" : "ganbke",
      "is_test" : false,
      "name" : "Georgia Northern Bankruptcy Court",
      "subdomain" : "ecf.ganb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.N.D.Ga.TEST",
      "code" : "ganbtrain",
      "is_test" : true,
      "name" : "Georgia Northern TEST Bankruptcy Court",
      "subdomain" : "ecf-train.ganb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "11",
      "citation" : "Bankr.S.D.Ga.",
      "code" : "gasbke",
      "is_test" : false,
      "name" : "Georgia Southern Bankruptcy Court",
      "subdomain" : "ecf.gasb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Guam",
      "code" : "gubke",
      "is_test" : false,
      "name" : "Guam Bankruptcy Court",
      "subdomain" : "ecf.gub.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Hawaii",
      "code" : "hibke",
      "is_test" : false,
      "name" : "Hawaii Bankruptcy Court",
      "subdomain" : "ecf.hib.uscourts.gov",
      "timezone" : "US/Hawaii",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.N.D.Iowa",
      "code" : "ianbke",
      "is_test" : false,
      "name" : "Iowa Northern Bankruptcy Court",
      "subdomain" : "ecf.ianb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.S.D.Iowa",
      "code" : "iasbke",
      "is_test" : false,
      "name" : "Iowa Southern Bankruptcy Court",
      "subdomain" : "ecf.iasb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Idaho",
      "code" : "idbke",
      "is_test" : false,
      "name" : "Idaho Bankruptcy Court",
      "subdomain" : "ecf.idb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.C.D.Ill.",
      "code" : "ilcbke",
      "is_test" : false,
      "name" : "Illinois Central Bankruptcy Court",
      "subdomain" : "ecf.ilcb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.N.D.Ill.",
      "code" : "ilnbke",
      "is_test" : false,
      "name" : "Illinois Northern Bankruptcy Court",
      "subdomain" : "ecf.ilnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.S.D.Ill.",
      "code" : "ilsbke",
      "is_test" : false,
      "name" : "Illinois Southern Bankruptcy Court",
      "subdomain" : "ecf.ilsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.N.D.Ind.",
      "code" : "innbke",
      "is_test" : false,
      "name" : "Indiana Northern Bankruptcy Court",
      "subdomain" : "ecf.innb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.S.D.Ind.",
      "code" : "insbke",
      "is_test" : false,
      "name" : "Indiana Southern Bankruptcy Court",
      "subdomain" : "ecf.insb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Kan.",
      "code" : "ksbke",
      "is_test" : false,
      "name" : "Kansas Bankruptcy Court",
      "subdomain" : "ecf.ksb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Ky.",
      "code" : "kyebke",
      "is_test" : false,
      "name" : "Kentucky Eastern Bankruptcy Court",
      "subdomain" : "ecf.kyeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Ky.",
      "code" : "kywbke",
      "is_test" : false,
      "name" : "Kentucky Western Bankruptcy Court",
      "subdomain" : "ecf.kywb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.E.D.La.",
      "code" : "laebke",
      "is_test" : false,
      "name" : "Louisiana Eastern Bankruptcy Court",
      "subdomain" : "ecf.laeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.M.D.La.",
      "code" : "lambke",
      "is_test" : false,
      "name" : "Louisiana Middle Bankruptcy Court",
      "subdomain" : "ecf.lamb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.W.D.La.",
      "code" : "lawbke",
      "is_test" : false,
      "name" : "Louisiana Western Bankruptcy Court",
      "subdomain" : "ecf.lawb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.Mass.",
      "code" : "mabke",
      "is_test" : false,
      "name" : "Massachusetts Bankruptcy Court",
      "subdomain" : "ecf.mab.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.D.Md.",
      "code" : "mdbke",
      "is_test" : false,
      "name" : "Maryland Bankruptcy Court",
      "subdomain" : "ecf.mdb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.Me.",
      "code" : "mebke",
      "is_test" : false,
      "name" : "Maine Bankruptcy Court",
      "subdomain" : "ecf.meb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Mich.",
      "code" : "miebke",
      "is_test" : false,
      "name" : "Michigan Eastern Bankruptcy Court",
      "subdomain" : "ecf.mieb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Mich.",
      "code" : "miwbke",
      "is_test" : false,
      "name" : "Michigan Western Bankruptcy Court",
      "subdomain" : "ecf.miwb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.Minn.",
      "code" : "mnbke",
      "is_test" : false,
      "name" : "Minnesota Bankruptcy Court",
      "subdomain" : "ecf.mnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.E.D.Mo.",
      "code" : "moebke",
      "is_test" : false,
      "name" : "Missouri Eastern Bankruptcy Court",
      "subdomain" : "ecf.moeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.W.D.Mo.",
      "code" : "mowbke",
      "is_test" : false,
      "name" : "Missouri Western Bankruptcy Court",
      "subdomain" : "ecf.mowb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.N.D.Miss",
      "code" : "msnbke",
      "is_test" : false,
      "name" : "Mississippi Northern Bankruptcy Court",
      "subdomain" : "ecf.msnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.S.D.Miss.",
      "code" : "mssbke",
      "is_test" : false,
      "name" : "Mississippi Southern Bankruptcy Court",
      "subdomain" : "ecf.mssb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Mont.",
      "code" : "mtbke",
      "is_test" : false,
      "name" : "Montana Bankruptcy Court",
      "subdomain" : "ecf.mtb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.E.D.N.C.",
      "code" : "ncebke",
      "is_test" : false,
      "name" : "North Carolina Eastern Bankruptcy Court",
      "subdomain" : "ecf.nceb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.M.D.N.C.",
      "code" : "ncmbke",
      "is_test" : false,
      "name" : "North Carolina Middle Bankruptcy Court",
      "subdomain" : "ecf.ncmb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.W.D.N.C.",
      "code" : "ncwbke",
      "is_test" : false,
      "name" : "North Carolina Western Bankruptcy Court",
      "subdomain" : "ecf.ncwb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.N.D.",
      "code" : "ndbke",
      "is_test" : false,
      "name" : "North Dakota Bankruptcy Court",
      "subdomain" : "ecf.ndb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.Neb.",
      "code" : "nebke",
      "is_test" : false,
      "name" : "Nebraska Bankruptcy Court",
      "subdomain" : "ecf.neb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.N.H.",
      "code" : "nhbke",
      "is_test" : false,
      "name" : "New Hampshire Bankruptcy Court",
      "subdomain" : "ecf.nhb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.",
      "code" : "njbke",
      "is_test" : false,
      "name" : "New Jersey Bankruptcy Court",
      "subdomain" : "ecf.njb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.TEST.",
      "code" : "njbtest",
      "is_test" : true,
      "name" : "New Jersey TEST Bankruptcy Court",
      "subdomain" : "ecf-test.njb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.N.J.TRAIN.",
      "code" : "njbtrain",
      "is_test" : true,
      "name" : "New Jersey TRAIN Bankruptcy Court",
      "subdomain" : "ecf-train.njb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.N.M.",
      "code" : "nmbke",
      "is_test" : false,
      "name" : "New Mexico Bankruptcy Court",
      "subdomain" : "ecf.nmb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.N.M.ISS.",
      "code" : "nmibke",
      "is_test" : false,
      "name" : "Northern Mariana Islands Bankruptcy Court",
      "subdomain" : "ecf.nmib.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Nev.",
      "code" : "nvbke",
      "is_test" : false,
      "name" : "Nevada Bankruptcy Court",
      "subdomain" : "ecf.nvb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.E.D.N.Y.",
      "code" : "nyebke",
      "is_test" : false,
      "name" : "New York Eastern Bankruptcy Court",
      "subdomain" : "ecf.nyeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.N.D.N.Y.",
      "code" : "nynbke",
      "is_test" : false,
      "name" : "New York Northern Bankruptcy Court",
      "subdomain" : "ecf.nynb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.S.D.N.Y.",
      "code" : "nysbke",
      "is_test" : false,
      "name" : "New York Southern Bankruptcy Court",
      "subdomain" : "ecf.nysb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.W.D.N.Y.",
      "code" : "nywbke",
      "is_test" : false,
      "name" : "New York Western Bankruptcy Court",
      "subdomain" : "ecf.nywb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.N.D.Ohio",
      "code" : "ohnbke",
      "is_test" : false,
      "name" : "Ohio Northern Bankruptcy Court",
      "subdomain" : "ecf.ohnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.S.D.Ohio",
      "code" : "ohsbke",
      "is_test" : false,
      "name" : "Ohio Southern Bankruptcy Court",
      "subdomain" : "ecf.ohsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.E.D.Okla.",
      "code" : "okebke",
      "is_test" : false,
      "name" : "Oklahoma Eastern Bankruptcy Court",
      "subdomain" : "ecf.okeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.N.D.Okla.",
      "code" : "oknbke",
      "is_test" : false,
      "name" : "Oklahoma Northern Bankruptcy Court",
      "subdomain" : "ecf.oknb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.W.D.Okla.",
      "code" : "okwbke",
      "is_test" : false,
      "name" : "Oklahoma Western Bankruptcy Court",
      "subdomain" : "ecf.okwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.",
      "code" : "orbke",
      "is_test" : false,
      "name" : "Oregon Bankruptcy Court",
      "subdomain" : "ecf.orb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.TEST.",
      "code" : "orbtest",
      "is_test" : true,
      "name" : "Oregon TEST Bankruptcy Court",
      "subdomain" : "ecf-test.orb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.D.Or.TRAIN.",
      "code" : "orbtrain",
      "is_test" : true,
      "name" : "Oregon TRAIN Bankruptcy Court",
      "subdomain" : "ecf-train.orb.uscourts.gov",
      "timezone" : null,
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.E.D.Pa.",
      "code" : "paebke",
      "is_test" : false,
      "name" : "Pennsylvania Eastern Bankruptcy Court",
      "subdomain" : "ecf.paeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.M.D.Pa.",
      "code" : "pambke",
      "is_test" : false,
      "name" : "Pennsylvania Middle Bankruptcy Court",
      "subdomain" : "ecf.pamb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.W.D.Pa.",
      "code" : "pawbke",
      "is_test" : false,
      "name" : "Pennsylvania Western Bankruptcy Court",
      "subdomain" : "ecf.pawb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.P.R.",
      "code" : "prbke",
      "is_test" : false,
      "name" : "Puerto Rico Bankruptcy Court",
      "subdomain" : "ecf.prb.uscourts.gov",
      "timezone" : "America/Puerto_Rico",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "01",
      "citation" : "Bankr.D.R.I.",
      "code" : "ribke",
      "is_test" : false,
      "name" : "Rhode Island Bankruptcy Court",
      "subdomain" : "ecf.rib.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.D.S.C.",
      "code" : "scbke",
      "is_test" : false,
      "name" : "South Carolina Bankruptcy Court",
      "subdomain" : "ecf.scb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "08",
      "citation" : "Bankr.D.S.D.",
      "code" : "sdbke",
      "is_test" : false,
      "name" : "South Dakota Bankruptcy Court",
      "subdomain" : "ecf.sdb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.E.D.Tenn.",
      "code" : "tnebke",
      "is_test" : false,
      "name" : "Tennessee Eastern Bankruptcy Court",
      "subdomain" : "ecf.tneb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.M.D.Tenn.",
      "code" : "tnmbke",
      "is_test" : false,
      "name" : "Tennessee Middle Bankruptcy Court",
      "subdomain" : "ecf.tnmb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "06",
      "citation" : "Bankr.W.D.Tenn.",
      "code" : "tnwbke",
      "is_test" : false,
      "name" : "Tennessee Western Bankruptcy Court",
      "subdomain" : "ecf.tnwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.E.D.Tex.",
      "code" : "txebke",
      "is_test" : false,
      "name" : "Texas Eastern Bankruptcy Court",
      "subdomain" : "ecf.txeb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.N.D.Tex.",
      "code" : "txnbke",
      "is_test" : false,
      "name" : "Texas Northern Bankruptcy Court",
      "subdomain" : "ecf.txnb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.S.D.Tex.",
      "code" : "txsbke",
      "is_test" : false,
      "name" : "Texas Southern Bankruptcy Court",
      "subdomain" : "ecf.txsb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "05",
      "citation" : "Bankr.W.D.Tex.",
      "code" : "txwbke",
      "is_test" : false,
      "name" : "Texas Western Bankruptcy Court",
      "subdomain" : "ecf.txwb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Utah",
      "code" : "utbke",
      "is_test" : false,
      "name" : "Utah Bankruptcy Court",
      "subdomain" : "ecf.utb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.E.D.Va.",
      "code" : "vaebke",
      "is_test" : false,
      "name" : "Virginia Eastern Bankruptcy Court",
      "subdomain" : "ecf.vaeb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.W.D.Va.",
      "code" : "vawbke",
      "is_test" : false,
      "name" : "Virginia Western Bankruptcy Court",
      "subdomain" : "ecf.vawb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "03",
      "citation" : "Bankr.D.VirginIslands",
      "code" : "vibke",
      "is_test" : false,
      "name" : "Virgin Islands Bankruptcy Court",
      "subdomain" : "ecf.vib.uscourts.gov",
      "timezone" : "America/Virgin",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "02",
      "citation" : "Bankr.D.Vt.",
      "code" : "vtbke",
      "is_test" : false,
      "name" : "Vermont Bankruptcy Court",
      "subdomain" : "ecf.vtb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.E.D.Wash.",
      "code" : "waebke",
      "is_test" : false,
      "name" : "Washington Eastern Bankruptcy Court",
      "subdomain" : "ecf.waeb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Bankr.W.D.Wash.",
      "code" : "wawbke",
      "is_test" : false,
      "name" : "Washington Western Bankruptcy Court",
      "subdomain" : "ecf.wawb.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.E.D.Wis.",
      "code" : "wiebke",
      "is_test" : false,
      "name" : "Wisconsin Eastern Bankruptcy Court",
      "subdomain" : "ecf.wieb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "07",
      "citation" : "Bankr.W.D.Wis",
      "code" : "wiwbke",
      "is_test" : false,
      "name" : "Wisconsin Western Bankruptcy Court",
      "subdomain" : "ecf.wiwb.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.N.D.W.Va.",
      "code" : "wvnbke",
      "is_test" : false,
      "name" : "West Virginia Northern Bankruptcy Court",
      "subdomain" : "ecf.wvnb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "04",
      "citation" : "Bankr.S.D.W.Va.",
      "code" : "wvsbke",
      "is_test" : false,
      "name" : "West Virginia Southern Bankruptcy Court",
      "subdomain" : "ecf.wvsb.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "10",
      "citation" : "Bankr.D.Wyom.",
      "code" : "wybke",
      "is_test" : false,
      "name" : "Wyoming Bankruptcy Court",
      "subdomain" : "ecf.wyb.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "bankruptcy"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Alaska",
      "code" : "akdce",
      "is_test" : false,
      "name" : "Alaska District Court",
      "subdomain" : "ecf.akd.uscourts.gov",
      "timezone" : "US/Alaska",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Ala.",
      "code" : "almdce",
      "is_test" : false,
      "name" : "Alabama Middle District Court",
      "subdomain" : "ecf.almd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Ala.",
      "code" : "alndce",
      "is_test" : false,
      "name" : "Alabama Northern District Court",
      "subdomain" : "ecf.alnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Ala.",
      "code" : "alsdce",
      "is_test" : false,
      "name" : "Alabama Southern District Court",
      "subdomain" : "ecf.alsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.E.D.Ark.",
      "code" : "aredce",
      "is_test" : false,
      "name" : "Arkansas Eastern District Court",
      "subdomain" : "ecf.ared.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.W.D.Ark.",
      "code" : "arwdce",
      "is_test" : false,
      "name" : "Arkansas Western District Court",
      "subdomain" : "ecf.arwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Ariz.",
      "code" : "azdce",
      "is_test" : false,
      "name" : "Arizona District Court",
      "subdomain" : "ecf.azd.uscourts.gov",
      "timezone" : "US/Arizona",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.C.D.Cal.",
      "code" : "cacdce",
      "is_test" : false,
      "name" : "California Central District Court",
      "subdomain" : "ecf.cacd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.E.D.Cal.",
      "code" : "caedce",
      "is_test" : false,
      "name" : "California Eastern District Court",
      "subdomain" : "ecf.caed.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.D.Cal.",
      "code" : "candce",
      "is_test" : false,
      "name" : "California Northern District Court",
      "subdomain" : "ecf.cand.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.S.D.Cal.",
      "code" : "casdce",
      "is_test" : false,
      "name" : "California Southern District Court",
      "subdomain" : "ecf.casd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.Colo.",
      "code" : "codce",
      "is_test" : false,
      "name" : "Colorado District Court",
      "subdomain" : "ecf.cod.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.D.Conn.",
      "code" : "ctdce",
      "is_test" : false,
      "name" : "Connecticut District Court",
      "subdomain" : "ecf.ctd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "dc",
      "citation" : "Dist.D.D.C.",
      "code" : "dcdce",
      "is_test" : false,
      "name" : "District Of Columbia District Court",
      "subdomain" : "ecf.dcd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "dc",
      "citation" : "Dist.TEST",
      "code" : "dctest",
      "is_test" : true,
      "name" : "District TEST Court",
      "subdomain" : "dcecf.psc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.D.Del.",
      "code" : "dedce",
      "is_test" : false,
      "name" : "Delaware District Court",
      "subdomain" : "ecf.ded.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Fla.",
      "code" : "flmdce",
      "is_test" : false,
      "name" : "Florida Middle District Court",
      "subdomain" : "ecf.flmd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Fla.",
      "code" : "flndce",
      "is_test" : false,
      "name" : "Florida Northern District Court",
      "subdomain" : "ecf.flnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Fla.TEST.",
      "code" : "flndtest",
      "is_test" : true,
      "name" : "Florida Northern TEST District Court",
      "subdomain" : "ecf-test.flnd.uscourts.gov",
      "timezone" : null,
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Fla.",
      "code" : "flsdce",
      "is_test" : false,
      "name" : "Florida Southern District Court",
      "subdomain" : "ecf.flsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.M.D.Ga.",
      "code" : "gamdce",
      "is_test" : false,
      "name" : "Georgia Middle District Court",
      "subdomain" : "ecf.gamd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.N.D.Ga.",
      "code" : "gandce",
      "is_test" : false,
      "name" : "Georgia Northern District Court",
      "subdomain" : "ecf.gand.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "11",
      "citation" : "Dist.S.D.Ga.",
      "code" : "gasdce",
      "is_test" : false,
      "name" : "Georgia Southern District Court",
      "subdomain" : "ecf.gasd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Guam",
      "code" : "gudce",
      "is_test" : false,
      "name" : "Guam District Court",
      "subdomain" : "ecf.gud.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Hawaii",
      "code" : "hidce",
      "is_test" : false,
      "name" : "Hawaii District Court",
      "subdomain" : "ecf.hid.uscourts.gov",
      "timezone" : "US/Hawaii",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.N.D.Iowa",
      "code" : "iandce",
      "is_test" : false,
      "name" : "Iowa Northern District Court",
      "subdomain" : "ecf.iand.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.S.D.Iowa",
      "code" : "iasdce",
      "is_test" : false,
      "name" : "Iowa Southern District Court",
      "subdomain" : "ecf.iasd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Idaho",
      "code" : "iddce",
      "is_test" : false,
      "name" : "Idaho District Court",
      "subdomain" : "ecf.idd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.C.D.Ill.",
      "code" : "ilcdce",
      "is_test" : false,
      "name" : "Illinois Central District Court",
      "subdomain" : "ecf.ilcd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.N.D.Ill.",
      "code" : "ilndce",
      "is_test" : false,
      "name" : "Illinois Northern District Court",
      "subdomain" : "ecf.ilnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.S.D.Ill.",
      "code" : "ilsdce",
      "is_test" : false,
      "name" : "Illinois Southern District Court",
      "subdomain" : "ecf.ilsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.N.D.Ind.",
      "code" : "inndce",
      "is_test" : false,
      "name" : "Indiana Northern District Court",
      "subdomain" : "ecf.innd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.S.D.Ind.",
      "code" : "insdce",
      "is_test" : false,
      "name" : "Indiana Southern District Court",
      "subdomain" : "ecf.insd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.Kan.",
      "code" : "ksdce",
      "is_test" : false,
      "name" : "Kansas District Court",
      "subdomain" : "ecf.ksd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.Kan.TEST.",
      "code" : "ksdtest",
      "is_test" : true,
      "name" : "Kansas TEST District Court",
      "subdomain" : "ecf-test.ksd.uscourts.gov",
      "timezone" : null,
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Ky.",
      "code" : "kyedce",
      "is_test" : false,
      "name" : "Kentucky Eastern District Court",
      "subdomain" : "ecf.kyed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Ky.",
      "code" : "kywdce",
      "is_test" : false,
      "name" : "Kentucky Western District Court",
      "subdomain" : "ecf.kywd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.W.D.La.",
      "code" : "laedce",
      "is_test" : false,
      "name" : "Louisiana Eastern District Court",
      "subdomain" : "ecf.laed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.M.D.La.",
      "code" : "lamdce",
      "is_test" : false,
      "name" : "Louisiana Middle District Court",
      "subdomain" : "ecf.lamd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.W.D.La.",
      "code" : "lawdce",
      "is_test" : false,
      "name" : "Louisiana Western District Court",
      "subdomain" : "ecf.lawd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.D.Mass.",
      "code" : "madce",
      "is_test" : false,
      "name" : "Massachusetts District Court",
      "subdomain" : "ecf.mad.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.D.Md.",
      "code" : "mddce",
      "is_test" : false,
      "name" : "Maryland District Court",
      "subdomain" : "ecf.mdd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.D.Me.",
      "code" : "medce",
      "is_test" : false,
      "name" : "Maine District Court",
      "subdomain" : "ecf.med.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Mich.",
      "code" : "miedce",
      "is_test" : false,
      "name" : "Michigan Eastern District Court",
      "subdomain" : "ecf.mied.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Mich.",
      "code" : "miwdce",
      "is_test" : false,
      "name" : "Michigan Western District Court",
      "subdomain" : "ecf.miwd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.Minn.",
      "code" : "mndce",
      "is_test" : false,
      "name" : "Minnesota District Court",
      "subdomain" : "ecf.mnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.Minn.TEST.",
      "code" : "mndtest",
      "is_test" : true,
      "name" : "Minnesota TEST District Court",
      "subdomain" : "ecf-test.mnd.uscourts.gov",
      "timezone" : null,
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.Minn.TRAIN.",
      "code" : "mndtrain",
      "is_test" : true,
      "name" : "Minnesota TRAIN District Court",
      "subdomain" : "ecf-train.mnd.uscourts.gov",
      "timezone" : null,
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.W.D.Mo.",
      "code" : "moedce",
      "is_test" : false,
      "name" : "Missouri Eastern District Court",
      "subdomain" : "ecf.moed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.W.D.Mo.",
      "code" : "mowdce",
      "is_test" : false,
      "name" : "Missouri Western District Court",
      "subdomain" : "ecf.mowd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.N.D.Miss",
      "code" : "msndce",
      "is_test" : false,
      "name" : "Mississippi Northern District Court",
      "subdomain" : "ecf.msnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.S.D.Miss.",
      "code" : "mssdce",
      "is_test" : false,
      "name" : "Mississippi Southern District Court",
      "subdomain" : "ecf.mssd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Mont.",
      "code" : "mtdce",
      "is_test" : false,
      "name" : "Montana District Court",
      "subdomain" : "ecf.mtd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.E.D.N.C.",
      "code" : "ncedce",
      "is_test" : false,
      "name" : "North Carolina Eastern District Court",
      "subdomain" : "ecf.nced.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.M.D.N.C.",
      "code" : "ncmdce",
      "is_test" : false,
      "name" : "North Carolina Middle District Court",
      "subdomain" : "ecf.ncmd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.W.D.N.C.",
      "code" : "ncwdce",
      "is_test" : false,
      "name" : "North Carolina Western District Court",
      "subdomain" : "ecf.ncwd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.N.D.",
      "code" : "nddce",
      "is_test" : false,
      "name" : "North Dakota District Court",
      "subdomain" : "ecf.ndd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.Neb.",
      "code" : "nedce",
      "is_test" : false,
      "name" : "Nebraska District Court",
      "subdomain" : "ecf.ned.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.D.N.H.",
      "code" : "nhdce",
      "is_test" : false,
      "name" : "New Hampshire District Court",
      "subdomain" : "ecf.nhd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.D.N.J.",
      "code" : "njdce",
      "is_test" : false,
      "name" : "New Jersey District Court",
      "subdomain" : "ecf.njd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.N.M.",
      "code" : "nmdce",
      "is_test" : false,
      "name" : "New Mexico District Court",
      "subdomain" : "ecf.nmd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.M.ISS.",
      "code" : "nmidce",
      "is_test" : false,
      "name" : "Northern Mariana Islands District Court",
      "subdomain" : "ecf.nmid.uscourts.gov",
      "timezone" : "Pacific/Guam",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Nev.",
      "code" : "nvdce",
      "is_test" : false,
      "name" : "Nevada District Court",
      "subdomain" : "ecf.nvd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.N.D.TEST.",
      "code" : "nvdtest",
      "is_test" : true,
      "name" : "Nevada District TEST Court",
      "subdomain" : "ecf-test.nvd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.E.D.N.Y.",
      "code" : "nyedce",
      "is_test" : false,
      "name" : "New York Eastern District Court",
      "subdomain" : "ecf.nyed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.N.D.N.Y.",
      "code" : "nyndce",
      "is_test" : false,
      "name" : "New York Northern District Court",
      "subdomain" : "ecf.nynd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.S.D.N.Y.",
      "code" : "nysdce",
      "is_test" : false,
      "name" : "New York Southern District Court",
      "subdomain" : "ecf.nysd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.W.D.N.Y.",
      "code" : "nywdce",
      "is_test" : false,
      "name" : "New York Western District Court",
      "subdomain" : "ecf.nywd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.N.D.Ohio",
      "code" : "ohndce",
      "is_test" : false,
      "name" : "Ohio Northern District Court",
      "subdomain" : "ecf.ohnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.N.D.Ohio",
      "code" : "ohndea",
      "is_test" : false,
      "name" : "Ohio Northern District Court(asbestos)",
      "subdomain" : "ecf-asbestos.ohnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.S.D.Ohio",
      "code" : "ohsdce",
      "is_test" : false,
      "name" : "Ohio Southern District Court",
      "subdomain" : "ecf.ohsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.E.D.Okla.",
      "code" : "okedce",
      "is_test" : false,
      "name" : "Oklahoma Eastern District Court",
      "subdomain" : "ecf.oked.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.N.D.Okla.",
      "code" : "okndce",
      "is_test" : false,
      "name" : "Oklahoma Northern District Court",
      "subdomain" : "ecf.oknd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.W.D.Okla.",
      "code" : "okwdce",
      "is_test" : false,
      "name" : "Oklahoma Western District Court",
      "subdomain" : "ecf.okwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.D.Or.",
      "code" : "ordce",
      "is_test" : false,
      "name" : "Oregon District Court",
      "subdomain" : "ecf.ord.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.E.D.Pa.",
      "code" : "paedce",
      "is_test" : false,
      "name" : "Pennsylvania Eastern District Court",
      "subdomain" : "ecf.paed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.M.D.Pa.",
      "code" : "pamdce",
      "is_test" : false,
      "name" : "Pennsylvania Middle District Court",
      "subdomain" : "ecf.pamd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.W.D.Pa.",
      "code" : "pawdce",
      "is_test" : false,
      "name" : "Pennsylvania Western District Court",
      "subdomain" : "ecf.pawd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.D.P.R.",
      "code" : "prdce",
      "is_test" : false,
      "name" : "Puerto Rico District Court",
      "subdomain" : "ecf.prd.uscourts.gov",
      "timezone" : "America/Puerto_Rico",
      "type" : "district"
   },
   {
      "circuit" : "01",
      "citation" : "Dist.D.R.I.",
      "code" : "ridce",
      "is_test" : false,
      "name" : "Rhode Island District Court",
      "subdomain" : "ecf.rid.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.D.S.C.",
      "code" : "scdce",
      "is_test" : false,
      "name" : "South Carolina District Court",
      "subdomain" : "ecf.scd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "08",
      "citation" : "Dist.D.S.D.",
      "code" : "sddce",
      "is_test" : false,
      "name" : "South Dakota District Court",
      "subdomain" : "ecf.sdd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.E.D.Tenn.",
      "code" : "tnedce",
      "is_test" : false,
      "name" : "Tennessee Eastern District Court",
      "subdomain" : "ecf.tned.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.M.D.Tenn.",
      "code" : "tnmdce",
      "is_test" : false,
      "name" : "Tennessee Middle District Court",
      "subdomain" : "ecf.tnmd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "06",
      "citation" : "Dist.W.D.Tenn.",
      "code" : "tnwdce",
      "is_test" : false,
      "name" : "Tennessee Western District Court",
      "subdomain" : "ecf.tnwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.E.D.Tex.",
      "code" : "txedce",
      "is_test" : false,
      "name" : "Texas Eastern District Court",
      "subdomain" : "ecf.txed.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.N.D.Tex.",
      "code" : "txndce",
      "is_test" : false,
      "name" : "Texas Northern District Court",
      "subdomain" : "ecf.txnd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.S.D.Tex.",
      "code" : "txsdce",
      "is_test" : false,
      "name" : "Texas Southern District Court",
      "subdomain" : "ecf.txsd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "05",
      "citation" : "Dist.W.D.Tex.",
      "code" : "txwdce",
      "is_test" : false,
      "name" : "Texas Western District Court",
      "subdomain" : "ecf.txwd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.D.Utah",
      "code" : "utdce",
      "is_test" : false,
      "name" : "Utah District Court",
      "subdomain" : "ecf.utd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.E.D.Va.",
      "code" : "vaedce",
      "is_test" : false,
      "name" : "Virginia Eastern District Court",
      "subdomain" : "ecf.vaed.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.W.D.Va.",
      "code" : "vawdce",
      "is_test" : false,
      "name" : "Virginia Western District Court",
      "subdomain" : "ecf.vawd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "03",
      "citation" : "Dist.D.VirginIslands",
      "code" : "vidce",
      "is_test" : false,
      "name" : "Virgin Islands District Court",
      "subdomain" : "ecf.vid.uscourts.gov",
      "timezone" : "America/Virgin",
      "type" : "district"
   },
   {
      "circuit" : "02",
      "citation" : "Dist.D.Vt.",
      "code" : "vtdce",
      "is_test" : false,
      "name" : "Vermont District Court",
      "subdomain" : "ecf.vtd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.E.D.Wash.",
      "code" : "waedce",
      "is_test" : false,
      "name" : "Washington Eastern District Court",
      "subdomain" : "ecf.waed.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "09",
      "citation" : "Dist.W.D.Wash.",
      "code" : "wawdce",
      "is_test" : false,
      "name" : "Washington Western District Court",
      "subdomain" : "ecf.wawd.uscourts.gov",
      "timezone" : "US/Pacific",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.E.D.Wis.",
      "code" : "wiedce",
      "is_test" : false,
      "name" : "Wisconsin Eastern District Court",
      "subdomain" : "ecf.wied.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "07",
      "citation" : "Dist.W.D.Wis",
      "code" : "wiwdce",
      "is_test" : false,
      "name" : "Wisconsin Western District Court",
      "subdomain" : "ecf.wiwd.uscourts.gov",
      "timezone" : "US/Central",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.N.D.W.Va.",
      "code" : "wvndce",
      "is_test" : false,
      "name" : "West Virginia Northern District Court",
      "subdomain" : "ecf.wvnd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "04",
      "citation" : "Dist.S.D.W.Va.",
      "code" : "wvsdce",
      "is_test" : false,
      "name" : "West Virginia Southern District Court",
      "subdomain" : "ecf.wvsd.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "district"
   },
   {
      "circuit" : "10",
      "citation" : "Dist.E.D.Wis.",
      "code" : "wydce",
      "is_test" : false,
      "name" : "Wyoming District Court",
      "subdomain" : "ecf.wyd.uscourts.gov",
      "timezone" : "US/Mountain",
      "type" : "district"
   },
   {
      "circuit" : "fc",
      "citation" : "INT",
      "code" : "citdce",
      "is_test" : false,
      "name" : "U.S. Court of International Trade",
      "subdomain" : "ecf.cit.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   },
   {
      "circuit" : "fc",
      "citation" : "Fed.Claim",
      "code" : "cofce",
      "is_test" : false,
      "name" : "US Court of Federal Claims",
      "subdomain" : "ecf.cofc.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   },
   {
      "circuit" : null,
      "citation" : "JPML",
      "code" : "jpml",
      "is_test" : false,
      "name" : "Judicial Panel on Multidistrict Litigation",
      "subdomain" : "ecf.jpml.uscourts.gov",
      "timezone" : "US/Eastern",
      "type" : "national"
   }
]



/** WEBPACK FOOTER **
 ** ./src/data/courts.js
 **/